import gridNames from 'common/gridNames';
import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import ZipCodesManagementSrv from './ZipCodesManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.zipCodesManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return ZipCodesManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return function() {
    return ZipCodesManagementSrv.add(model);
  };
}

export function updateAsync(model) {
  return function() {
    return ZipCodesManagementSrv.update(model);
  };
}
